<template>
  <div class="select-tree">
    <TreeItem
      v-for="item in value"
      :key="item.value"
      :value="item"
      :root="true"
      :depth="1"
      @on-change="onTreeItemChanged"
    ></TreeItem>
  </div>
</template>
<script>
export default {
  name: "SelectTree",
  props: {
    value: Array, // 树结构源数据
  },
  methods: {
    onTreeItemChanged() {
      this.$emit("on-change", this.value);
    },
  },
};
</script>
<style lang="stylus" scoped>
.select-tree
  padding 0 20px
  max-height 300px
  overflow auto

  &::-webkit-scrollbar
    width 6px
    background-color transparentify

  &::-webkit-scrollbar-thumb
    background #ddd
    border-radius 6px

  >>>.node-row
    display flex
    position relative
    padding-right 70px

    .node-handler
      display none
      margin-left 10px
      position absolute
      right 0

      .node-handler-btn
        margin-left 5px

    &:hover
      .node-handler
        display block
</style>
